import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const ToolsMenuContainer = styled.div`
  padding: 6.5px 0;
  background-color: ${Variables.colors.complementary};
`;
export const ToolsListContainer = styled.div`
  overflow-y: auto;
  height: auto;
  overflow-x: hidden;
  width: 100%;
  .item-separator {
    width: 100%;
    height: 1px;
    background-color: ${Variables.colors.complementary_300};
  }

  .tool-item {
    cursor: pointer;
    background-color: ${Variables.colors.complementary};
    height: 32px;
    list-style-type: none;
    display: flex;
    a,
    .disabled-a {
      width: 100%;
      padding: 12px 16px;
      display: flex;
      align-items: center;
      //justify-content: space-between;
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.medium};
      line-height: 1.62;
      text-decoration: none;
      .link-external-icon {
        display: none;
        &:before {
          margin: 0 !important;
          font-size: 16px;
          color: ${Variables.colors.complementary_500};
        }
      }
      .icon {
        margin-right: 8px;
        color: ${Variables.colors.yellow_500};
      }
      &.disable-link {
        cursor: not-allowed;
      }
      span {
        display: flex;
        align-items: center;
      }
    }
    &:hover {
      background-color: ${Variables.colors.complementary_200};
      .link-external-icon {
        display: block;
      }
    }
  }
`;

export const StyledCardListOfLinks = styled.div`
  background-color: ${Variables.colors.white};
  border-bottom: 1px solid ${Variables.colors.complementary_400};
  margin-top: 8px;
  padding-bottom: 8px;
  .title {
    font-size: ${Variables.font_sizes.small};
    color: ${Variables.colors.complementary_600};
    margin-bottom: 8px;
    padding: 0 16px;
  }
  &:last-child {
    border-bottom: 0;
  }
`;
